import { debounce } from './utility.js';

// ビューポートサイズをCSS変数にセット
const setViewportSize = () => {
    document.documentElement.style.setProperty('--vw', `${window.innerWidth * 0.01}px`);
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
};

const setupViewportSize = () => {
    setViewportSize();
    window.addEventListener('resize', debounce(setViewportSize, 100));
};

// スクロール量に応じてヘッダーの位置を変更
const setupHeaderLayout = () => {
    const header = document.querySelector('.layout-header');

    window.addEventListener('scroll', () => {
        if (window.scrollY > header.clientHeight) {
			document.body.classList.add('is-scrolled');
        } else {
			document.body.classList.remove('is-scrolled');
        }
    });
};

export const initLayoutControl = () => {
    setupViewportSize();
    setupHeaderLayout();
};
